import React from 'react';

type BadgeVariant =
  | 'active' |'pending' |'approved' |'rejected' |'processed' |'draft' |'submitted' |'paid' |'clocked-in' |'clocked-out' |'on-leave' |'overdue' |'warning';

const VARIANT_STYLES: Record<BadgeVariant, string> = {
  active: 'bg-success/10 text-success',
  pending: 'bg-warning/10 text-warning',
  approved: 'bg-primary/10 text-primary',
  rejected: 'bg-danger/10 text-danger',
  processed: 'bg-accent/10 text-accent',
  draft: 'bg-muted text-muted-foreground',
  submitted: 'bg-info/10 text-info',
  paid: 'bg-success/10 text-success',
  'clocked-in': 'bg-success/10 text-success',
  'clocked-out': 'bg-muted text-muted-foreground',
  'on-leave': 'bg-accent/10 text-accent',
  overdue: 'bg-danger/10 text-danger',
  warning: 'bg-warning/10 text-warning',
};

const VARIANT_LABELS: Record<BadgeVariant, string> = {
  active: 'Active',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  processed: 'Processed',
  draft: 'Draft',
  submitted: 'Submitted',
  paid: 'Paid',
  'clocked-in': 'Clocked In',
  'clocked-out': 'Clocked Out',
  'on-leave': 'On Leave',
  overdue: 'Overdue',
  warning: 'Warning',
};

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ variant, label, size = 'md' }: StatusBadgeProps) {
  return (
    <span
      className={`
        inline-flex items-center gap-1 font-500 rounded-full
        ${VARIANT_STYLES[variant]}
        ${size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-[11px] px-2 py-1'}
      `}
    >
      <span
        className={`w-1.5 h-1.5 rounded-full ${
          variant === 'clocked-in' || variant === 'active'
            ? 'bg-success animate-pulse'
            : variant === 'pending' || variant === 'warning'
            ? 'bg-warning'
            : variant === 'rejected' || variant === 'overdue'
            ? 'bg-danger'
            : variant === 'approved' || variant === 'submitted'
            ? 'bg-primary'
            : variant === 'paid' ?'bg-success' :'bg-muted-foreground'
        }`}
      />
      {label ?? VARIANT_LABELS[variant]}
    </span>
  );
}